module.exports = __webpack_public_path__ + "static/p2-73cf9f2aa886c99c14a7a6cf67cc798d.png";